interface RoutesItem {name: string; href: string; icon: string;}

export const routes: RoutesItem[] = [
    {name: "Resolution Requests", href: "/request-list", icon: "request"}
];

interface Shortcuts {
	image: string;
	url: string;
}

export const shortcuts: Shortcuts[] = [
	{
		image: "/images/admiral-vector.svg",
		url: `${process.env.REACT_APP_ADMIRAL_APP}`,
	},
	{
		image: "/images/account-vector.svg",
		url: `${process.env.REACT_APP_ACCOUNT_APP}`,
	},
	{
		image: "/images/security-vector.svg",
		url: `${process.env.REACT_APP_SECURITY_APP}`,
	},
];
// token declaration
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;

const IS_PROD = DOMAIN_NAME === "level5fleet.com";

export const ACCESS_TOKEN_KEY = IS_PROD
	? "prod_l5_accessToken"
	: "preprod_l5_accessToken";
export const REFRESH_TOKEN_KEY = IS_PROD
	? "prod_l5_refreshToken"
	: "preprod_l5_refreshToken";

// export const ACCESS_TOKEN_KEY: string = "l5_accessToken";
// export const REFRESH_TOKEN_KEY: string = "l5_refreshToken";

export const COOKIES_COMPANY_ID: string = "l5_companyId";
export const COOKIES_USER_ID: string = "l5_userId";
export const COOKIES_USER_ROLE: string = "l5_userRole";
export const COOKIES_COMPANY_NAME: string = "l5_companyName";
export const COOKIES_OTHER_APP_PROVISION: string = "fromProvision"; // from other app cookies
export const COOKIES_FROM_PROVISION: string = "fromProvisionTMU"; // from fleet cookies
export const COOKIES_LP: string = "trailerLp";
export const COOKIES_TRAILER_ID: string = "trailerId";
export const COOKIES_TMU_ID: string = "tmuId";
export const AFTER_VERIFICATION: string = "verification_next_step";

export const PAGE_LIMIT = 15;
export const USER_EMAIL = "admin3@maeu.com";
export const ACCESS_LINK = {
    apple: "https://apps.apple.com/be/app/admiral-access/id6502579460",
    google: "https://play.google.com/store/apps/details?id=corp.l5fleet.utf" +
    "&hl=en_CA"
};
export const WEBSOCKET_CLIENT_ACTIONS = {
    fetchActiveChats: "fetchActiveChatMessages",
    fetchArchivedChats: "fetchArchivedChatMessages",
    fetchIntents: "fetchIntents",
    fetchNewChatMessages: "fetchNewChatMessages",
    sendMessage: "sendMessage",
    readMessage: "readMessage",
};

export const WEBSOCKET_RESPONSE_TYPE = {
    allChatMessages: "activeChatMessages",
    archivedChats: "archivedChatMessages",
    assignmentRequestVerified: "resolverUpdated",
    cancellationRequestVerified: "requestCancelled",
    chatArchived: "chatArchived",
    creationRequestVerified: "requestCreated",
    identityVerified: "identityVerified",
    intentsRetrieved: "intentsRetrieved",
    intentRevoked: "intentRevoked",
    newChatCreated: "newChatCreated",
    messageSent: "newRequestMessages",
    newMessage: "newMessage",
    readMessage: "readMessage",
    resolutionVerified: "requestResolved",
};

export const COMPANY_ROLE = {
  shipper: "shipper",
  carrier: "carrier",
  consignee: "consignee",
};
